export default __webpack_public_path__ + "static/media/no_img.1eb8f2f3.png";